import { Badge } from 'antd';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import NotifyApi from '../../functions/api/user/NotifyApi';

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countNotify: 0,
    };
  }

  componentDidMount = async () => {
    await this.getCountNotify();

    setInterval(async () => {
      await this.getCountNotify();
    }, 5 * 60 * 1000);
  };

  getCountNotify = async () => {
    const countNotify = await NotifyApi.countUnreadNotify();

    this.setState({ countNotify });
  };

  render() {
    const { countNotify } = this.state;

    return (
      <div className="d-inline-block mr-3">
        <Badge count={countNotify} size="small">
          <Link to="/notify" className="text-body">
            <i className="fas fa-bell"></i>
          </Link>
        </Badge>
      </div>
    );
  }
}

export default Notification;
